module.exports = __webpack_public_path__ + "images/59f14a863599560519a8ed140c5924f5.svg";